export default "__VITE_ASSET__839b985c__"